function selectItem(selector) {
    return document.querySelector(selector);
}

var w = null; //speedtest worker

var s = new Speedtest(); //create speedtest object
s.setParameter("telemetry_level", "basic"); //enable telemetry
s.setParameter("url_telemetry", "results/telemetry");

var server = {
    name: "demo",
    server: "https://c6n9s.com",
    dlURL: "backend/garbage.php",
    pingURL: "backend/empty.php",
    getIpURL: "backend/getIP.php",
};

s.setSelectedServer(server);

var uiData;

function I(i) {
    return document.querySelector(i);
}
var stopBtn = selectItem(".js-stop-speedtest-button");
stopBtn.addEventListener('click', stopSpeedTest);
var startBtn = selectItem(".js-start-speedtest-button");
startBtn.addEventListener('click', startSpeedTest)
function startSpeedTest() {
    //test is not running, begin
    initUI();
    var listItems = document.querySelectorAll(".custom-list__item");
    for (var i = 0; i < listItems.length; i++) {
        listItems[i].classList.remove("custom-list__item--active");
    }

    selectItem(".js-stop-speedtest-button").className = selectItem(".js-stop-speedtest-button").className.replace(new RegExp(" hidden", "g"), "");
    selectItem(".js-start-speedtest-button").className += " hidden";
    selectItem(".js-download-speed-value").textContent = "0.00";
    selectItem(".js-ping-speed-value").textContent = "0.00";
    selectItem(".js-jitter-speed-value").textContent = "0.00";
    selectItem(".js-speed-value").textContent = "0.00";
    selectItem(".js-speedometer-percentage").textContent = "0%";
    selectItem(".js-ping-speed-value").parentNode.parentNode.className += " custom-list__item--active";
    selectItem(".js-jitter-speed-value").parentNode.parentNode.className += " custom-list__item--active";

    s.onupdate = function (data) {
        uiData = data;
        if (!data) return;
        if (uiData == null) return;
        updateUI();
    };

    function updateUI() {
        var status = uiData.testState;
        I(".js-download-speed-value").textContent = format(uiData.dlStatus);
        I(".js-ping-speed-value").textContent = format(uiData.pingStatus);
        I(".js-jitter-speed-value").textContent = format(uiData.jitterStatus);

        I(".js-speedometer-test").textContent = "Download Speed";
        var speedValue = 0;
        var speedProgress = 0;
        if (status == 1) {
            if (!selectItem(".js-download-speed-value").parentNode.parentNode.classList.contains("custom-list__item--active")) {
                selectItem(".js-speed-value").className += " speedometer__speed-value--active";
                selectItem(".js-speedometer-percentage").className += " speedometer__percentage--active";
                selectItem(".js-download-speed-value").parentNode.parentNode.classList.add("custom-list__item--active");
            }
            speedValue = uiData.dlStatus
            speedProgress = uiData.dlProgress;
        }

        var style = (711 - (711 * (speedValue >= 100 ? 0.96 : +speedValue / 100))) + "px";
        I(".js-speed-progressbar").style.strokeDashoffset = style;
        I(".js-speedometer-percentage").textContent = (Math.round(100 * speedProgress)) + "%";
        I(".js-speed-value").textContent = format(speedValue);

    }

    function format(d) {
        d = Number(d);
        if (d < 10) return d.toFixed(2);
        if (d < 100) return d.toFixed(1);
        return d.toFixed(0);
    }

    s.start();
}

function stopSpeedTest() {
    if (s.getState() == 3) {
        //speedtest is running, abort
        s.abort();
        // data = null;
        selectItem(".js-start-speedtest-button").className = selectItem(".js-start-speedtest-button").className.replace(new RegExp(" hidden", "g"), "");
        selectItem(".js-stop-speedtest-button").className += " hidden";
        initUI();
    }
}

s.onend = function () {
    selectItem(".js-start-speedtest-button").className = selectItem(".js-start-speedtest-button").className.replace(new RegExp(" hidden", "g"), "");
    selectItem(".js-stop-speedtest-button").className += " hidden";
};
//function to (re)initialize UI
function initUI() {
    var listItems = document.querySelectorAll(".custom-list__item");
    for (var i = 0; i < listItems.length; i++) {
        listItems[i].className = listItems[i].className.replace(" custom-list__item--active", "");
    }
    selectItem(".js-download-speed-value").textContent = "0.00";
    selectItem(".js-ping-speed-value").textContent = "0.00";
    selectItem(".js-jitter-speed-value").textContent = "0.00";
    selectItem(".js-speedometer-percentage").textContent = "0%";
    selectItem(".js-speed-progressbar").style.strokeDashoffset = "711px";
    selectItem(".js-speed-value").textContent = "0.00";
    selectItem(".js-speedometer-percentage").textContent = "0%";
    selectItem(".js-speed-value").className = selectItem(".js-speed-value").className.replace(new RegExp(" speedometer__speed-value--active", "g"), "");
    selectItem(".js-speedometer-percentage").className = selectItem(".js-speedometer-percentage").className.replace(new RegExp(" speedometer__percentage--active", "g"), "");
}

